import { motion } from "framer-motion";

export const Header = () => (
  <motion.header
    className="site-header"
    initial={{ y: -70 }}
    animate={{ y: 0 }}
    transition={{ duration: 0.8, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
    data-testid="site-header"
  >
    <div className="wrap">
      <a href="#top" className="brand" data-testid="brand-link">
        <span className="brand-name">Sorted</span>
        <span className="brand-tag">Malta</span>
      </a>
      <a href="#apply" className="btn-brass btn-brass--small" data-testid="header-cta">
        Become a founding tasker
      </a>
    </div>
  </motion.header>
);
